import { createReducer, on } from '@ngrx/store'
import * as dashboardActions from './dashboard.actions'
import { OutstandingBalance, } from './dashboard.interfaces'

export interface DashboardState {
    outstandingBalance: OutstandingBalance,
    outstandingBalanceError: boolean
    loadingOutstandingBalance: boolean

}

export const initialState: DashboardState = {
    outstandingBalance: null,
    outstandingBalanceError: null,
    loadingOutstandingBalance: null,

}

export const DashboardReducer = createReducer(
    initialState,

    on(dashboardActions.fetchOutstandingBalance, (state) => ({
        ...state, outstandingBalance: null, outstandingBalanceError: null, loadingOutstandingBalance: true
    })),

    on(dashboardActions.fetchOutstandingBalanceSuccess, (state, {outstandingBalance}) => ({
        ...state, outstandingBalance: outstandingBalance, outstandingBalanceError: false, loadingOutstandingBalance: false
    })),

    on(dashboardActions.fetchOutstandingBalanceFailed, (state) => ({
        ...state, outstandingBalance: null, outstandingBalanceError: true, loadingOutstandingBalance: false
    })),


)